import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { Loader } from 'components/Loader/Loader';
import { ErrorHandler } from 'pages/ErrorHandler/ErrorHandler';
import { useAuthContext } from 'utils/contexts/AuthContext';
import { AuthState } from 'utils/contexts/AuthContext/AuthContextType';
import rg4js from 'raygun4js';

export const LoadAccount = () => {
    const { pathname: path } = useLocation();
    const { loadAccount, authState } = useAuthContext();

    useEffect(() => {
        if (authState === AuthState.UNKNOWN) {
            // not sure if user is authenticated, try loading account to find out
            loadAccount();
        }
    }, [loadAccount, authState]);

    useEffect(() => {
        rg4js('trackEvent', {
            type: 'pageView',
            path: path,
        });
    }, [path]);

    if (authState === AuthState.ERROR) {
        return <ErrorHandler />;
    }

    return authState === AuthState.UNKNOWN ? <Loader /> : <Outlet />;
};
